<svg
	xmlns:svg="http://www.w3.org/2000/svg"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 36 36"
	width="100%"
	height="100%"
	version="1.1">
	 <path
		d="M18 2.0845
			a 15.9155 15.9155 0 0 1 0 31.831
			a 15.9155 15.9155 0 0 1 0 -31.831"
		fill="none"
		stroke="#ddd"
		stroke-width="4"
	 />
	 <path
		d="M18 2.0845
			a 15.9155 15.9155 0 0 1 0 31.831
			a 15.9155 15.9155 0 0 1 0 -31.831"
		fill="none"
		stroke={{config.color}}
		stroke-width="4"
		stroke-dasharray="{{config.percent}}, 100"
	 />
	 <text x="18" y="20" font-size="5" text-anchor="middle" fill="black">{{config.percent}}%</text>
</svg>
